goog.provide("shadow.js.shim.module$zustand$middleware");
goog.provide("module$shadow_js_shim_module$zustand$middleware");
shadow.js.shim.module$zustand$middleware = shadow.js.nativeProvides["zustand/middleware"] = shadow$bridge("zustand/middleware");
module$shadow_js_shim_module$zustand$middleware.default = shadow.js.shim.module$zustand$middleware;
